import Area from '@/components/Area';
import {
  AccumulativeShadows,
  Edges,
  Environment,
  OrbitControls,
  Outlines,
  RandomizedLight,
  useGLTF,
} from '@react-three/drei';
import { Canvas, MeshProps } from '@react-three/fiber';
import * as React from 'react';
import gltfModel from './day58_aluminium_bracket-transformed.glb';
import * as THREE from 'three';

function Model(props: MeshProps) {
  const { nodes } = useGLTF(gltfModel);
  const Cube = nodes.defaultMaterial as THREE.Mesh;
  const [hovered, setHovered] = React.useState(false);
  // console.log('Model', { nodes });
  return (
    <mesh
      geometry={Cube.geometry}
      // material={Cube.material}
      castShadow
      receiveShadow
      onPointerOver={() => setHovered(true)}
      onPointerOut={() => setHovered(false)}
      {...props}
    >
      <meshStandardMaterial
        roughness={0.15}
        metalness={0.5}
        // opacity={0.9} transparent
      />
      <Edges linewidth={2} threshold={15} color={hovered ? '#c02040' : 'black'} />
      <Outlines thickness={0.01} color={hovered ? '#c02040' : 'black'} />
    </mesh>
  );
}

export type Props = {};

function App02(props: Props) {
  const {} = props;

  return (
    <Area>
      {() => (
        <Canvas shadows camera={{ position: [-5, 2.5, 5], fov: 35 }}>
          <ambientLight intensity={Math.PI / 8} />
          <spotLight intensity={Math.PI} decay={0} angle={0.2} castShadow position={[5, 2.5, 5]} shadow-mapSize={128} />
          <Model position={[0, 0.19, 0]} rotation={[0, 0, -Math.PI / 4.45]} />
          <AccumulativeShadows frames={100} temporal>
            <RandomizedLight radius={2} position={[5, 2.5, 5]} />
          </AccumulativeShadows>
          <OrbitControls makeDefault dampingFactor={0.3} />
          <Environment preset="sunset" />
        </Canvas>
      )}
    </Area>
  );
}

export default React.memo(App02);
